import { T } from "../Constants";
import { useSelector } from "react-redux";

const useTableState = () => useSelector((redux: T.ReduxSelector) => redux.table_state);

export default useTableState;